import React, { useState, useEffect, useCallback } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";
import moment from "moment";
import axios from "axios";

export default function DataTable_Component({
  apidata,
  columns,
  searchBy,
  totalRows,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,

  dataFilter,
  setDataFilter,

  employeeFilter,
  setEmployeeFilter,

  categoryFilter,
  setCategoryFilter,

  hubFilter,
  setHubFilter,

  vehicleFilter,
  setVehicleFilter,

  startDate,
  setStartDate,

  endDate,
  setEndDate,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [categories, setCategories] = useState([]);
  const [hubs, setHubs] = useState([]);
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setVehicles(response.data.vehicles || []);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    };

    fetchVehicles();
  }, []);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setEmployees(res.data.users || []);
      } catch (err) {
        console.error("Employee fetch error", err);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    const fetchHubs = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setHubs(res.data.hubs || []);
      } catch (err) {
        console.error("Hub fetch error", err);
      }
    };

    fetchHubs();
  }, []);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/expense-categories`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setCategories(response.data.expenseCategories || []);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCategory();
  }, []);

  const isValidDate = (date) => {
    return moment(date, "YYYY-MM-DD", true).isValid();
  };

  const applyFilters = () => {
    setCurrentPage(1);
    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setDataFilter("");
    setEmployeeFilter("");
    setCategoryFilter("");
    setHubFilter("");
    setStartDate("");
    setEndDate("");
    setVehicleFilter("");
    setCurrentPage(1);
    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => {
              setDataFilter(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={apidata}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={rowsPerPage}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        paginationDefaultPage={currentPage}
        onChangePage={(page) => setCurrentPage(page)}
        onChangeRowsPerPage={(perPage) => {
          setRowsPerPage(perPage);
        }}
        fixedHeader
        highlightOnHover
        responsive
      />

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        employeeFilter={employeeFilter}
        setEmployeeFilter={setEmployeeFilter}
        categoryFilter={categoryFilter}
        setCategoryFilter={setCategoryFilter}
        hubFilter={hubFilter}
        setHubFilter={setHubFilter}
        vehicleFilter={vehicleFilter}
        setVehicleFilter={setVehicleFilter}
        vehicles={vehicles}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        employees={employees}
        categories={categories}
        hubs={hubs}
      />
    </div>
  );
}

function debounce(func, delay) {
  let timeout;
  const debouncedFunc = (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
  debouncedFunc.cancel = () => clearTimeout(timeout);
  return debouncedFunc;
}
